import * as React from 'react';
import {autoprefixer} from 'diy/material-ui/autoprefixer';
import l10n = require('diy/util/l10n');
import IconTextButton from "diy/custom-components/icon-text-button/IconTextButton";
import AutoIcon from 'material-ui/svg-icons/content/font-download';
import Column2 from 'material-ui/svg-icons/action/view-agenda';
import Column3 from 'material-ui/svg-icons/action/view-column';
import Column4 from 'material-ui/svg-icons/action/view-headline';
import SameSize from 'material-ui/svg-icons/action/view-module';
import Stretch from 'material-ui/svg-icons/maps/zoom-out-map';

export interface ColumnSettingsProps {
    activeColumn: number;
    fitMode: number;
    availableColumns: number[];

    onColumnNumberSelected?(val: number): void;
    onFitModeChanged?(modeFit: number): void;
}

interface ColumnSettingsState {
}

export class ColumnSettings extends React.Component<ColumnSettingsProps, ColumnSettingsState> {
    render() {
        let styles = this.getStyles();
        return (
            <div style={styles.container}>
                <div style={styles.containerTitle}>{l10n.getString('section.columnSettings.columnsTitle')}</div>
                <div style={styles.columnsContainer}>
                    <IconTextButton
                        text={l10n.getString('section.columnSettings.columnsAuto')}
                        Icon={<AutoIcon/>}
                        style={styles.iconTextButton}
                        buttonStyle={styles.button}
                        onTouchTap={() => {this.props.onColumnNumberSelected(0);}}
                        useAlternativeColors={true}
                        isPressed={this.props.activeColumn === 0}
                        dataTestId={"columns-type-0"}
                    />
                    {this.props.availableColumns.indexOf(2) !== -1 ?
                    <IconTextButton
                        text={l10n.getString('section.columnSettings.columns2')}
                        Icon={<Column2 style={autoprefixer({
                            transform: 'rotate(90deg)'
                        })}/>}
                        style={styles.iconTextButton}
                        buttonStyle={styles.button}
                        onTouchTap={() => {this.props.onColumnNumberSelected(2);}}
                        useAlternativeColors={true}
                        isPressed={this.props.activeColumn === 2}
                        dataTestId={"columns-type-2"}
                    /> : null }
                    {this.props.availableColumns.indexOf(3) !== -1 ?
                    <IconTextButton
                        text={l10n.getString('section.columnSettings.columns3')}
                        Icon={<Column3/>}
                        style={styles.iconTextButton}
                        buttonStyle={styles.button}
                        onTouchTap={() => {this.props.onColumnNumberSelected(3);}}
                        useAlternativeColors={true}
                        isPressed={this.props.activeColumn === 3}
                        dataTestId={"columns-type-3"}
                    /> : null }
                    {this.props.availableColumns.indexOf(4) !== -1 ?
                    <IconTextButton
                        text={l10n.getString('section.columnSettings.columns4')}
                        Icon={<Column4 style={autoprefixer({
                            transform: 'rotate(90deg)'
                        })}/>}
                        style={styles.iconTextButton}
                        buttonStyle={styles.button}
                        onTouchTap={() => {this.props.onColumnNumberSelected(4);}}
                        useAlternativeColors={true}
                        isPressed={this.props.activeColumn === 4}
                        dataTestId={"columns-type-4"}
                    /> : null }
                </div>
                <div style={styles.containerTitle}>{l10n.getString('section.columnSettings.fitModeTitle')}</div>
                <div style={styles.fitModeContainer}>
                    <IconTextButton
                        text={l10n.getString('section.columnSettings.fitModeStretch')}
                        Icon={<Stretch/>}
                        style={styles.iconTextButton}
                        buttonStyle={styles.button}
                        onTouchTap={() => {this.props.onFitModeChanged(1);}}
                        useAlternativeColors={true}
                        isPressed={this.props.fitMode === 1}
                        dataTestId={"columns-fitModeStretch"}
                    />
                    <IconTextButton
                        text={l10n.getString('section.columnSettings.fitModeSameSize')}
                        Icon={<SameSize/>}
                        style={styles.iconTextButton}
                        buttonStyle={styles.button}
                        onTouchTap={() => {this.props.onFitModeChanged(0);}}
                        useAlternativeColors={true}
                        isPressed={this.props.fitMode === 0}
                        dataTestId={"columns-fitModeSameSize"}
                    />
                </div>
            </div>
        );
    }

    private getStyles() {
        return {
            container: autoprefixer({
                padding: 5
            }),
            containerTitle: autoprefixer({
                fontFamily: 'open sans',
                fontSize: '14px',
                lineHeight: '14px',
                padding: '6px 6px 6px 6px',
                color: '#666'
            }),
            columnsContainer: autoprefixer({
                display: 'block',
                marginBottom: 16,
                maxWidth: 190
            }),
            fitModeContainer: {
                display: 'block',
                maxWidth: 190
            },
            iconTextButton: autoprefixer({
                width: 80,
                padding: 6
            }),
            button: autoprefixer({
                width: "100%"
            }),
            zone: {
                marginRight: 8
            }
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/common/ColumnSettings.tsx
 **/